// The theme's native code
// if ( typeof ProductQuantity !== 'function' ) {

// 	class ProductQuantity extends HTMLElement {

// 		constructor(){

// 			super();

// 			const qty = this.querySelector('.qty-selector'),
// 						qtyMinus = this.querySelector('.qty-minus'),
// 						qtyPlus = this.querySelector('.qty-plus'),
// 						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
// 						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

// 			if ( parseInt(qty.value) - 1 < qtyMin ) {
// 				qtyMinus.classList.add('disabled');
// 			}
// 			if ( parseInt(qty.value) + 1 > qtyMax ) {
// 				qtyPlus.classList.add('disabled');
// 			}

// 			qtyMinus.addEventListener('click', (e)=>{
// 				e.preventDefault();
// 				if ( ! qtyMinus.classList.contains('disabled') ) {
// 					const currentQty = parseInt(qty.value);
// 					if ( currentQty - 1 >= qtyMin ) {
// 						qty.value = currentQty - 1;
// 						qtyPlus.classList.remove('disabled');
// 					} 
// 					if ( currentQty - 1 <= qtyMin ) {
// 						qtyMinus.classList.add('disabled');
// 					}
// 				}
// 			});

// 			qtyPlus.addEventListener('click', (e)=>{
// 				e.preventDefault();
// 				if ( ! qtyPlus.classList.contains('disabled') ) {
// 					const currentQty = parseInt(qty.value);
// 					if ( currentQty + 1 <= qtyMax ) {
// 						qty.value = currentQty + 1;
// 						qtyMinus.classList.remove('disabled');
// 					} 
// 					if ( currentQty + 1 >= qtyMax ) {
// 						qtyPlus.classList.add('disabled');
// 					}
// 				}
// 			});

// 		}
		
// 	}


//   if ( typeof customElements.get('product-quantity') == 'undefined' ) {
//     customElements.define('product-quantity', ProductQuantity);
// 	}

// }

//Adapted script for minimum purchase quantity
if (typeof ProductQuantity !== 'function') {

  class ProductQuantity extends HTMLElement {

    constructor() {
      super();

      const qty = this.querySelector('.qty-selector'),
            qtyMinus = this.querySelector('.qty-minus'),
            qtyPlus = this.querySelector('.qty-plus');

      // Validate and adjust quantity on load
      this.validateAndAdjustQuantity();
      
      // Initial button state update
      this.updateButtonStates();

      // Add input event listener for manual quantity changes
      qty.addEventListener('input', () => {
        this.validateAndAdjustQuantity();
        this.updateButtonStates();
      });

      qtyMinus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyMinus.classList.contains('disabled')) {
          // Get current values dynamically
          const currentQty = parseInt(qty.value);
          const qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1;
          const qtyMultiple = qty.dataset.multiple ? parseInt(qty.dataset.multiple) : 1;
          
          // console.log('currentQty-', currentQty, 'qtyMin:', qtyMin, 'qtyMultiple:', qtyMultiple);
          const newQty = currentQty - qtyMultiple; // Decrease by the multiple value

          if (newQty >= qtyMin) {
            qty.value = newQty;
            this.validateAndAdjustQuantity();
            this.updateButtonStates();
          }
        }
      });

      qtyPlus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyPlus.classList.contains('disabled')) {
          // Get current values dynamically
          const currentQty = parseInt(qty.value);
          const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 54000;
          const qtyMultiple = qty.dataset.multiple ? parseInt(qty.dataset.multiple) : 1;
          
          // console.log('currentQty+', currentQty, 'qtyMax:', qtyMax, 'qtyMultiple:', qtyMultiple);
          const newQty = currentQty + qtyMultiple; // Increase by the multiple value

          if (newQty <= qtyMax) {
            qty.value = newQty;
            this.validateAndAdjustQuantity();
            this.updateButtonStates();
          }
        }
      });
    }

    // Method to validate and adjust quantity based on multiple value
    validateAndAdjustQuantity() {
      const qty = this.querySelector('.qty-selector');
      const currentQty = parseInt(qty.value) || 1;
      
      // Check if multiple dataset exists and is not blank
      // if (qty.dataset.multiple && qty.dataset.multiple.trim() !== '') {
      //   const qtyMultiple = parseInt(qty.dataset.multiple);
        
      //   // Check if current quantity is divisible by multiple
      //   if (currentQty % qtyMultiple !== 0) {
      //     // Round up to the next multiple
      //     const adjustedQty = Math.ceil(currentQty / qtyMultiple) * qtyMultiple;
      //     qty.value = adjustedQty;
      //   }
      // }
    }

    // Method to update button states based on current values
    updateButtonStates() {
      const qty = this.querySelector('.qty-selector'),
            qtyMinus = this.querySelector('.qty-minus'),
            qtyPlus = this.querySelector('.qty-plus');
      
      // Get current values dynamically
      const currentQty = parseInt(qty.value);
      const qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1;
      const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 54000;
      const qtyMultiple = qty.dataset.multiple ? parseInt(qty.dataset.multiple) : 1;

      // Update minus button state
      if (currentQty - qtyMultiple < qtyMin) {
        qtyMinus.classList.add('disabled');
      } else {
        qtyMinus.classList.remove('disabled');
      }

      // Update plus button state
      if (currentQty + qtyMultiple > qtyMax) {
        qtyPlus.classList.add('disabled');
      } else {
        qtyPlus.classList.remove('disabled');
      }
    }
  }

  if (typeof customElements.get('product-quantity') == 'undefined') {
    customElements.define('product-quantity', ProductQuantity);
  }
}